/** @typedef {{ name: string; id: string; previewImage: string; data: string }} Layout */

/**
 * @returns {Layout[]}
 */
export function getListingLayouts() {
  return [
  {
    name: "Single Column Layout",
    id: "single",
    previewImage: "https://placehold.co/200x150/e1e1e1/666666?text=Single+Layout",
    data: String.raw`
<table class="{{cssClasses}}"{{{listingRefAttr}}} role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="max-width: 600px; margin: 0 auto; background-color: {{backgroundColor}}; font-size: 14px;">
<tr>
<td style="padding: {{padding}}; vertical-align: middle; font-size: 14px; line-height: normal;">{{#each listings}}<table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color: #ffffff; border-radius: 8px; margin-bottom: 15px;">
<tr>
<td style="padding: 15px;">
<table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
<tr>
<td style="text-align: center;">
<a href="{{../href}}" style="display: block; text-decoration: none;">
<img src="{{{{raw}}}}{{imagePath}}{{{{/raw}}}}" alt="Listing Image" width="570" style="width: 100%; max-width: 570px; height: auto; border-radius: 8px; display: block; margin: 0 auto;"/>
</a>
</td>
</tr>
<tr>
<td height="15" style="height: 15px; font-size: 1px; line-height: 1px;">&nbsp;</td>
</tr>
<tr>
<td>{{#if ../showAddress}}<h3 style="font-size: {{../titleFontSize}}; color: {{../listingNameColor}}; margin: 0 0 10px; padding: 0; font-weight: bold; word-wrap: break-word;"><a href="{{../href}}" style="display: block; text-decoration: none; color: inherit;">{{{{raw}}}}{{address}}<br/>{{city}}, {{stateProvince}} {{postalCode}}{{{{/raw}}}}</a></h3>{{/if}}
{{#if ../showPrice}}<p style="font-size: {{../priceFontSize}}; color: {{../listingPriceColor}}; margin: 0 0 10px; padding: 0; font-weight: bold; word-wrap: break-word;">{{{{raw}}}}{{listPrice}}{{{{/raw}}}}</p>{{/if}}
{{#if ../showDetails}}<p style="font-size: {{../addressFontSize}}; color: {{../listingAddressColor}}; margin: 0 0 15px; padding: 0; word-wrap: break-word;">{{{{raw}}}}{{beds}}{{{{/raw}}}} beds • {{{{raw}}}}{{baths}}{{{{/raw}}}} baths • {{{{raw}}}}{{sqFoot}}{{{{/raw}}}} sq ft</p>{{/if}}
<table role="presentation" cellspacing="0" cellpadding="0" border="0" align="center">
<tr>
<td height="40" bgcolor="{{../buttonColor}}" style="height: 40px; border-radius: 4px; background-color: {{../buttonColor}}; text-align: center; padding: 0 20px; mso-padding-alt: 0 20px 0 20px;"><a href="{{../href}}" style="display: block; height: 40px; color: {{../buttonTextColor}}; text-decoration: none; font-weight: bold; font-size: {{../buttonFontSize}}; line-height: 40px; font-family: Arial, sans-serif; mso-line-height-rule: exactly; white-space: nowrap;"><span style="color: {{#if ../buttonTextColor}}{{../buttonTextColor}}{{else}}#ffffff{{/if}};">{{#if ../buttonText}}{{../buttonText}}{{else}}More Info{{/if}}</span></a>
</td>
</tr>
</table>
</td>
</tr>
</table>
</td>
</tr>
</table>{{/each}}</td>
</tr>
</table>
`,
  },

  {
    name: "Double Column Layout",
    id: "double",
    previewImage: "https://placehold.co/200x150/e1e1e1/666666?text=Double+Layout",
    data: String.raw`
  <style type="text/css">
  @media only screen and (max-width: 640px) {
  .listing-double-col {
  display: block !important;
  width: 100% !important;
  max-width: 100% !important;
    min-width: 0 !important;
  float: none !important;
    box-sizing: border-box !important;
    margin: 0 0 15px 0 !important;
    padding: 0 !important;
  }
  .listing-double-gutter {
  padding: 0 !important;
  }
  .listing-double-card {
  padding: 12px !important;
  }
  .listing-double-image {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  }
  }
  </style>
<!--[if mso]>
<table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="max-width: 600px;">
<tr>
<![endif]-->
<table class="{{cssClasses}}"{{{listingRefAttr}}} role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="max-width: 600px; margin: 0 auto; background-color: {{backgroundColor}}; font-size: 14px;">
<tr>
<td style="padding: {{padding}}; vertical-align: middle; font-size: 0; line-height: normal; text-align: left;">{{#each listings}}<!--[if mso]>
<td valign="top" width="290" style="padding: 0 0 20px 0;">
<![endif]-->
<div class="listing-double-col" style="display: inline-block; width: 50%; min-width: 0; max-width: none; vertical-align: top; margin: 0 0 15px 0; font-size: 14px;">
<table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="width: 100%;">
<tr>
<td class="listing-double-gutter" style="padding: 0 5px;">
<table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="width: 100%;">
<tr>
<td class="listing-double-card" style="background-color: #ffffff; border-radius: 8px; padding: 15px; font-size: 14px;">
<table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
<tr>
<td style="text-align: center;">
<a href="{{../href}}" style="display: block; text-decoration: none;">
<img class="listing-double-image" src="{{{{raw}}}}{{imagePath}}{{{{/raw}}}}" alt="Listing Image" width="250" style="width: 100%; max-width: 250px; height: auto; border-radius: 8px; display: block; margin: 0 auto;"/>
</a>
</td>
</tr>
<tr>
<td height="15" style="height: 15px; font-size: 1px; line-height: 1px;">&nbsp;</td>
</tr>
<tr>
<td style="text-align: center;">{{#if ../showAddress}}<h3 style="text-align: center; font-size: {{../titleFontSize}}; color: {{../listingNameColor}}; margin: 0 0 10px; padding: 0; font-weight: bold; word-wrap: break-word;"><a href="{{../href}}" style="display: block; text-decoration: none; color: inherit;">{{{{raw}}}}{{address}}<br/>{{city}}, {{stateProvince}} {{postalCode}}{{{{/raw}}}}</a></h3>{{/if}}
{{#if ../showPrice}}<p style="text-align: center; font-size: {{../priceFontSize}}; color: {{../listingPriceColor}}; margin: 0 0 10px; padding: 0; font-weight: bold; word-wrap: break-word;">{{{{raw}}}}{{listPrice}}{{{{/raw}}}}</p>{{/if}}
{{#if ../showDetails}}<p style="text-align: center; font-size: {{../addressFontSize}}; color: {{../listingAddressColor}}; margin: 0 0 15px; padding: 0; word-wrap: break-word;">{{{{raw}}}}{{beds}}{{{{/raw}}}} beds • {{{{raw}}}}{{baths}}{{{{/raw}}}} baths • {{{{raw}}}}{{sqFoot}}{{{{/raw}}}} sq ft</p>{{/if}}
<table role="presentation" cellspacing="0" cellpadding="0" border="0" align="center">
<tr>
<td height="40" bgcolor="{{../buttonColor}}" style="height: 40px; border-radius: 4px; background-color: {{../buttonColor}}; text-align: center; padding: 0 20px; mso-padding-alt: 0 20px 0 20px;"><a href="{{../href}}" style="display: block; height: 40px; color: {{../buttonTextColor}}; text-decoration: none; font-weight: bold; font-size: {{../buttonFontSize}}; line-height: 40px; font-family: Arial, sans-serif; mso-line-height-rule: exactly; white-space: nowrap;"><span style="color: {{#if ../buttonTextColor}}{{../buttonTextColor}}{{else}}#ffffff{{/if}};">{{#if ../buttonText}}{{../buttonText}}{{else}}More Info{{/if}}</span></a>
</td>
</tr>
</table>
</td>
</tr>
</table>
</td>
</tr>
</table>
</td>
</tr>
</table>
</div>
<!--[if mso]>
</td>
<![endif]-->{{/each}}<!--[if mso]>
</tr>
</table>
<![endif]-->
</td>
</tr>
</table>
`,
  },

  {
    name: "Table Layout",
    id: "table",
    previewImage: "https://placehold.co/200x150/e1e1e1/666666?text=Table+Layout",
    data: String.raw`
<style type="text/css">.listing-mobile-image,.listing-mobile-button{display:none!important;max-height:0!important;overflow:hidden!important;}.listing-mobile-image table,.listing-mobile-button table{mso-hide:all;}@media only screen and (max-width:480px){.listing-table-header{display:none!important;}.listing-table-row{display:block!important;}.listing-table-col-image,.listing-table-col-action{display:none!important;}.listing-table-col-details{display:block!important;width:100%!important;text-align:center!important;box-sizing:border-box!important;}.listing-mobile-image,.listing-mobile-button{display:block!important;max-height:none!important;overflow:visible!important;}.listing-mobile-image table,.listing-mobile-button table{mso-hide:none!important;display:inline-table!important;}.listing-mobile-button td{min-width:140px!important;}}</style>
<table class="{{cssClasses}}"{{{listingRefAttr}}} role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="max-width: 600px; margin: 0 auto; background-color: {{backgroundColor}}; padding: {{padding}}; box-sizing: border-box; overflow-wrap: break-word; width: 100%; border-collapse: collapse; font-family: Arial, sans-serif; display: table;">
<thead class="listing-table-header">
<tr style="background-color: #f5f5f5; font-weight: bold;">
<th width="90" style="padding: 8px; border: 1px solid #ddd; text-align: center; font-size: 14px; width: 90px;">Image</th>
<th style="padding: 8px; border: 1px solid #ddd; text-align: left; font-size: 14px;">Property Details</th>
<th width="140" style="padding: 8px; border: 1px solid #ddd; text-align: center; font-size: 14px; width: 140px;">Action</th>
</tr>
</thead>
<tbody>{{#each listings}}<tr class="listing-table-row">
<td class="listing-table-col-image" width="90" style="padding: 8px; border: 1px solid #ddd; text-align: center; width: 90px;">
<a href="{{../href}}" style="display: block;">
<img src="{{{{raw}}}}{{imagePath}}{{{{/raw}}}}" alt="Listing Image" style="width: 100px; height: auto; object-fit: cover; border-radius: 4px;"/>
</a>
</td>
<td class="listing-table-col-details" style="padding: 8px; border: 1px solid #ddd; word-wrap: break-word; overflow-wrap: break-word; text-align: left;">
<div class="listing-mobile-image" style="display: none; max-height: 0; overflow: hidden; mso-hide: all; margin: 0 0 10px 0;">
<a href="{{../href}}" style="display: block; text-decoration: none;">
<img src="{{{{raw}}}}{{imagePath}}{{{{/raw}}}}" alt="Listing Image" style="width: 100%; max-width: 220px; height: auto; border-radius: 6px; display: block; margin: 0 auto;"/>
</a>
</div>{{#if ../showAddress}}<div style="color: {{../listingNameColor}}; font-weight: bold; margin-bottom: 4px; font-size: {{../titleFontSize}}; word-wrap: break-word; overflow-wrap: break-word;"><a href="{{../href}}" style="display: block; text-decoration: none; color: inherit;">{{{{raw}}}}{{address}}<br/>{{city}}, {{stateProvince}} {{postalCode}}{{{{/raw}}}}</a></div>{{/if}}
{{#if ../showPrice}}<div style="color: {{../listingPriceColor}}; font-weight: bold; font-size: {{../priceFontSize}}; margin-bottom: 4px;">{{{{raw}}}}{{listPrice}}{{{{/raw}}}}</div>{{/if}}
{{#if ../showDetails}}<div style="color: {{../listingAddressColor}}; font-size: {{../addressFontSize}};">{{{{raw}}}}{{beds}}{{{{/raw}}}} beds • {{{{raw}}}}{{baths}}{{{{/raw}}}} baths • {{{{raw}}}}{{sqFoot}}{{{{/raw}}}} sq ft</div>{{/if}}
<div class="listing-mobile-button" style="display: none; max-height: 0; overflow: hidden; mso-hide: all; margin-top: 10px; text-align: center;">
<table role="presentation" cellspacing="0" cellpadding="0" border="0" align="center">
<tr>
<td height="40" bgcolor="{{../buttonColor}}" style="height: 40px; border-radius: 4px; background-color: {{../buttonColor}}; text-align: center; padding: 0 20px; mso-padding-alt: 0 20px 0 20px;"><a href="{{../href}}" style="display: block; height: 40px; color: {{../buttonTextColor}}; text-decoration: none; font-weight: bold; font-size: {{../buttonFontSize}}; line-height: 40px; font-family: Arial, sans-serif; mso-line-height-rule: exactly; white-space: nowrap;"><span style="color: {{#if ../buttonTextColor}}{{../buttonTextColor}}{{else}}#ffffff{{/if}};">{{#if ../buttonText}}{{../buttonText}}{{else}}More Info{{/if}}</span></a>
</td>
</tr>
</table>
</div>
</td>
<td class="listing-table-col-action" width="140" style="padding: 8px; border: 1px solid #ddd; text-align: center; width: 140px;">
<table role="presentation" cellspacing="0" cellpadding="0" border="0" align="center">
<tr>
<td height="40" bgcolor="{{../buttonColor}}" style="height: 40px; border-radius: 4px; background-color: {{../buttonColor}}; text-align: center; padding: 0 20px; mso-padding-alt: 0 20px 0 20px;"><a href="{{../href}}" style="display: block; height: 40px; color: {{../buttonTextColor}}; text-decoration: none; font-weight: bold; font-size: {{../buttonFontSize}}; line-height: 40px; font-family: Arial, sans-serif; mso-line-height-rule: exactly; white-space: nowrap;"><span style="color: {{#if ../buttonTextColor}}{{../buttonTextColor}}{{else}}#ffffff{{/if}};">{{#if ../buttonText}}{{../buttonText}}{{else}}More Info{{/if}}</span></a>
</td>
</tr>
</table>
</td>
</tr>{{/each}}</tbody>
</table>
`,
  }
  ];
}

const listingLayouts = getListingLayouts();

export default listingLayouts;
